<template>
    <div>
        <el-table :data="tableData" :header-cell-style="headerCellStyle" :cell-style="cellStyle" border
            :style="tableStyle">
            <slot name="tableContent"></slot>
        </el-table>
        <div v-if="showPagination" class="new-pagination-page" :style="paginationStyle">
            <el-pagination @current-change="handleLeftCurrentChange" :current-page="count" background small
                :page-size="paginationNum" :pager-count="5" layout="total, prev, pager, next, jumper" class="pagination"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        productList: {
            type: Array,
            default: []
        },
        headerCellStyle: {
            type: Object,
            default: {}
        },
        cellStyle: {
            type: Object,
            default: {}
        },
        tableStyle: {
            type: String,
            default: "",
        },
        paginationStyle: {
            type: String,
            default: "",
        },
        paginationNum: {
            type: Number,
            default: 10,
        }
    },
    watch: {
        productList: {
            handler: function (v) {
                this.total = v.length
                this.count = 1
                if (v.length < this.paginationNum) {
                    this.tableData = v
                    this.showPagination = false
                } else {
                    this.tableData = v.slice(0, this.paginationNum);
                    this.showPagination = true
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            tableData: [],
            showPagination: false,
            total: 0,
            count: 1,
        }
    },
    methods: {
        handleLeftCurrentChange(page) {
            let paginationData = this.splitArrayIntoChunks(this.productList, this.paginationNum)
            this.tableData = paginationData[page - 1]
        },
        splitArrayIntoChunks(arr, chunkSize = 10) {
            const result = [];
            const arrLength = arr.length;

            for (let i = 0; i < arrLength; i += chunkSize) {
                // 从当前索引开始，截取最多chunkSize个元素
                result.push(arr.slice(i, i + chunkSize));
            }

            return result;
        }
    }
}
</script>
<style lang="scss" scoped></style>